import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const sectionClassName = css({
  padding: `0px ${Spacing.MD}px`,
  [SMALL_DEVICE_MQ]: {
    padding: `0px ${Spacing.LG}px`,
  },
});

export const spacingClassName = css({
  marginTop: Spacing.LG,
});

export const headerClassName = css({});

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
});

export const subheadingClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
  marginTop: Spacing.XS,
});

export const bodyClassName = css({});

export const bodySpacingClassName = css({
  marginTop: Spacing.SM,
});
